var nyr = (function () {

    var self = {};

        // Initialise custom functions
        self.init = function(mdg) {
        
        //Therapies
        initTherapyCartWatch();

        //Gift Message
        addGiftMessageListener();
        // Subscribe to cart updates to re-attach gift message listeners.
        // Guarded: nyr-base.js runs with data-cookieconsent="ignore" so it can execute
        // before/without pubsub.js + constants.js (which Cookiebot blocks pre-consent).
        // Without this guard, subscribe/PUB_SUB_EVENTS are undefined and init() throws.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                console.log("Cart updated - re-attaching gift message listeners");
                setTimeout(() => {
                    addGiftMessageListener();
                }, 100);
            });
        }

        //Initialize Product Notices Cart Interception
        initProductNoticesCartInterception();
    }

     /** UTITLITY METHODS */

     // Render a list of sections, return as list indexed by original key
      self.renderSections = async function(sectionNames) {
        const baseUrl = window.location.pathname;
        const sectionData = {};
    
        const fetchSection = async (sectionId) => {
            try {
                const response = await fetch(`${baseUrl}?section_id=${sectionId}`);
                if (!response.ok) throw new Error(`Failed to fetch section: ${sectionId}`);
                const html = await response.text();
                sectionData[sectionId] = html;
            } catch (error) {
                console.error(`Error loading section ${sectionId}:`, error);
            }
        };
    
        await Promise.all(sectionNames.map(fetchSection));
        return sectionData;
    }

    // Progress spinner start - elements must exist in page
    self.showSpinner = function() {
        spinnerOverlay.classList.remove('hidden')
    }

    // Progress spinner stop - elements must exist in page
    self.hideSpinner = function() {
        spinnerOverlay.classList.add('hidden');
    }

     // Remove variant from cart, trigger build event
     self.removeFromCart = function (variantId, qty, onComplete, container='') {
      // remove item
      let data = {
           id: variantId,
           quantity: qty
      }
      const cartUrl = "/cart/change.json";
      fetch(cartUrl, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function(){
        nyr.refreshCart();
        //onComplete(container);
      })

    }

    // Update Item
    self.updateItemInCart = function(key, properties) {
      
      let data = {
          'id': key,
          'properties': properties
      };

      fetch("/cart/change.json", {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
        .then(response => response.json())
        .then(function(){
          nyr.refreshCart();
        })
    }

    // Refresh cart drawer content using custom event
    self.refreshCart = function() {
      // Trigger the cart-drawer refresh event instead of calling methods directly
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    }

    /** END UTILITY METHODS */

    /** START: GIFT MESSAGE  */

  // Handle adding/removing of gift messages in cart drawer
  function addGiftMessageListener() {
    // Detect PDP
    let giftMessage = document.querySelector(".gift-message-textarea");
    let giftMessageOk = document.querySelector("#gift-message-button-ok");
    let giftMessageCancel = document.querySelector("#gift-message-button-cancel");
    
    if (giftMessage != undefined) {

        giftMessage.addEventListener('focus', function(evt) {
          document.querySelector(".gift-message-buttons").classList.remove('hide');
        });

        giftMessage.addEventListener('focusout', function(evt) {
          document.querySelector(".gift-message-buttons").classList.add('hide');
        });

        // OK Action
        ['mousedown', 'click'].forEach(function(e) {
          giftMessageOk.addEventListener(e, function(evt) {
            evt.preventDefault();

          
            // Validation - reset
            let validationContainer = document.getElementById('gift-message-validation');
            if (validationContainer) {
              validationContainer.innerHTML = ''
            }

            // Validation - max field length set in theme setting and validation message added as translation
            let lines = giftMessage.value.split(/\r\n|\r|\n/);
            if (giftMessage.value.length > window.giftMessageSettings.giftMessageMaxLength
              || lines.length > window.giftMessageSettings.giftMessageMaxLines) {
              if (validationContainer) {
                validationContainer.innerHTML = window.cartStrings.giftMessageToLong;
              }
              return;
            }

            giftMessageOk.classList.add('btn--loading');

            updateGiftMessage(giftMessage.value, () => {
              giftMessageOk.classList.remove('btn--loading');
              giftMessage.blur();
              document.querySelector(".gift-message-save-message").innerHTML = 'SAVED';
              setTimeout(() => { document.querySelector(".gift-message-save-message").innerHTML = ''; },2000 )
            }, () => {})

          });
       });

        // Cancel Action
        ['mousedown', 'click'].forEach(function(e) {
          giftMessageCancel.addEventListener(e, function(evt) {
            evt.preventDefault();

            // Validation - reset
            let validationContainer = document.getElementById('gift-message-validation');
            if (validationContainer) {
              validationContainer.innerHTML = ''
            }

            giftMessageCancel.classList.add('btn--loading');

            updateGiftMessage('', () => {
              giftMessage.value = '';
              giftMessageCancel.classList.remove('btn--loading');
              giftMessage.blur();
              // document.querySelector(".gift-message-save-message").innerHTML = 'SAVED';
              setTimeout(() => { document.querySelector(".gift-message-save-message").innerHTML = ''; },2000 )
            }, () => {})

          });
        });

      // Update Gift message stored with cart + callbacks 
      function updateGiftMessage(giftMessage, onSuccess, onError) {

        let data = {
          attributes: {
            'Gift Message': giftMessage
          }
        }

        fetch( window.routes.cart_url + '/update.js', {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            onError();
          } else {
            onSuccess();
          }

        });
      }
    }
    
  }
  /** END: GIFT MESSAGE  */

  /** START: PRODUCT NOTICES CART INTERCEPTION */
  
  // Intercept all add-to-cart operations to add product notices
  function initProductNoticesCartInterception() {
    
    // Override the global fetch function to intercept cart add requests
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const [url, options] = args;

    // Check if this is a cart add request
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart_add_url'))) {
      // Modify the request to include product notice if applicable
      return interceptCartAddRequest(originalFetch, url, options);
    }
      
      // For all other requests, use original fetch
      return originalFetch.apply(this, args);
    };

    // Also intercept form submissions for add-to-cart forms
    document.addEventListener('submit', function(event) {
      const form = event.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        interceptCartAddForm(form);
      }
    });

    //console.log('NYR: Product notices cart interception initialized');
  }

  // Intercept fetch-based cart add requests
  async function interceptCartAddRequest(originalFetch, url, options) {
    try {
      let modifiedOptions = { ...options };
      
      if (options && options.body) {
        let formData;
        let variantId;
        
        // Handle FormData
        if (options.body instanceof FormData) {
          formData = new FormData();
          // Copy existing form data
          for (let [key, value] of options.body.entries()) {
            formData.append(key, value);
            if (key === 'id') {
              variantId = value;
            }
          }
        }
        // Handle JSON body
        else if (typeof options.body === 'string') {
          try {
            const bodyData = JSON.parse(options.body);
            if (bodyData.id) {
              variantId = bodyData.id;
              // Add notice if available
              const notice = window.getNyrProductNotice ? window.getNyrProductNotice(variantId) : null;
              if (notice) {
                bodyData.properties = bodyData.properties || {};
                bodyData.properties['Notice'] = notice;
                modifiedOptions.body = JSON.stringify(bodyData);
                console.log('NYR: Added product notice to cart for variant', variantId, ':', notice);
              }
            }
          } catch (e) {
            // If parsing fails, continue with original body
            console.warn('NYR: Could not parse request body for notice injection');
          }
        }
        
        // For FormData, add notice property
        if (formData && variantId) {
          const notice = window.getNyrProductNotice ? window.getNyrProductNotice(variantId) : null;
          if (notice) {
            formData.append('properties[Notice]', notice);
            modifiedOptions.body = formData;
            console.log('NYR: Added product notice to cart for variant', variantId, ':', notice);
          }
        }
      }
      
      return originalFetch(url, modifiedOptions);
    } catch (error) {
      console.error('NYR: Error intercepting cart add request:', error);
      return originalFetch(url, options);
    }
  }

   // Close Modal - elements must exist in page
  self.closeModal = function() {
    const modalOverlay = document.querySelector('.wt-product__modal[open]');
    if (modalOverlay) {
        modalOverlay.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
    }
  };

  // Intercept form-based cart add submissions
  function interceptCartAddForm(form) {
    try {
      const variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = variantInput.value;
        const notice = window.getNyrProductNotice ? window.getNyrProductNotice(variantId) : null;
        
        if (notice) {
          // Check if notice property input already exists
          let noticeInput = form.querySelector('input[name="properties[Notice]"]');
          if (!noticeInput) {
            // Create hidden input for notice property
            noticeInput = document.createElement('input');
            noticeInput.type = 'hidden';
            noticeInput.name = 'properties[Notice]';
            form.appendChild(noticeInput);
          }
          noticeInput.value = notice;
          console.log('NYR: Added product notice to form for variant', variantId, ':', notice);
        }
      }
    } catch (error) {
      console.error('NYR: Error intercepting cart add form:', error);
    }
  }

  /** END: PRODUCT NOTICES CART INTERCEPTION */

  //** START: THERAPIES SUPPORT */
   
  // Check Cart for therapy items, run expiry checks
  function initTherapyCartWatch() {

    setTimeout(function() {

      let therapyItems = window.nyrSettings?.therapyCartItems ?? [];

      if (therapyItems.length > 0) {
        console.log('Validate Therapy Items');
        therapyItems.forEach(function(item){
          let now = new Date();
          let expires = new Date(item.expires_at.replace(' ','T'));
          // expires_at format: Y-m-d H:i:s
          if (expires > now) {
            // reservation valid, extend time to keep 15 min window active
            //console.log('therapy reservation extended - ' + item.reservation_id);
            nyr.extendReservation(item.reservation_id, item.key);
          } else {
            // expired - cancel and remove
            //console.log('therapy reservation expired - ' + item.reservation_id);
            nyr.cancelReservation(item.reservation_id, item.key);
          }

        })
      }
    }, 500);

  }

  // Remove a therapy item from the cart, cancel the reservation
  self.removeTherapyItemFromCart = function(elm) {
    nyr.cancelReservation(elm.getAttribute('data-reservation-id'), elm.getAttribute('data-key'));
  }

  // Therapy Item Expiry check
  self.therapyExpiredCheck = function(therapyItem) {

    let modalContent = 'Therapy reservation about to expire - please confirm if you would like to continue with the booking or cancel the reservation and rebook at a later date';
    modalContent += '<br/><br/> LINE ID: ' + therapyItem.line_id;
    modalContent += '<br/><br/> RESERVATION ID: ' + therapyItem.reservation_id;
   

  }

  // Extend expiry time on a therapy reservation
  self.extendReservation = async function(reservationId, lineKey, currentExpiryTime) {
  
    const response = await fetch("https://therapies-service.nealsyardremedies.com/" + 'api/appointments/reservation/extend', {
        method: 'POST',
        body: JSON.stringify({reservationId: reservationId}),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },        
        cache: 'no-cache',
    }).then(res => res.json())
      .then((res) => {
        if (typeof res == 'object' && res.id && res.status == 'open') {
            let start = new Date(res.mbo_start_time);
            let properties = {
              '_client_reference': res.client_reference,
              '_mbo_appointment_id': res.mbo_appointment_id,
              'Start Time': start.toLocaleString('en-GB'),
              'Session Type': res.mbo_session_type_name,
              'Duration': res.appointment_duration,
              'Location': res.mbo_location_name,
              '_location_phone_number': res.mbo_location_phone,
              '_location_address_1': res.mbo_location_address_1,
              '_location_address_2': res.mbo_location_address_2,
              '_location_city': res.mbo_location_city,
              '_location_postal_code': res.mbo_location_postal_code,
              '_therapist_name': res.therapist_name,
              '_reservation_id': res.id,
              '_expires_at': res.expires_at
            }
            nyr.updateItemInCart(lineKey, properties);
        } else {
          // reservation is not open - remove from cart
          nyr.removeFromCart(lineKey, 0, () => {});
          nyr.removeFromCart(lineKey, 0, function(){
            nyr.openModal('<p>Your therapy reservation has been automatically cancelled due to inactivity. To start the booking process again please visit our therapy appointment finder page</p>');
          });
        }
    })  

  }

  // Cancel a reservation
  self.cancelReservation = async function(reservationId, variantId, isTimeout = false) {

    var data = { reservationId: reservationId };

    const response = await fetch("https://therapies-service.nealsyardremedies.com/" + 'api/appointments/reservation/cancel', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        //mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache',
    }).then(data => {
        if (isTimeout) {
          nyr.removeFromCart(variantId, 0, function(){
            nyr.openModal('<p>Your therapy reservation has been automatically cancelled as your session was idle for more than 15 minuties. To start the booking process again please visit our therapy appointment finder page</p>');
          });
        } else {
          nyr.removeFromCart(variantId, 0, () => {});
        }
    });
  }

  //** END: THERAPIES SUPPORT */
    
  return self;
})();

(function() {

    function DOMready(callback) {
        if (document.readyState != 'loading') callback();
        else document.addEventListener('DOMContentLoaded', callback);
      }
  
    DOMready(nyr.init);
  })();


// PDP -> have only one accordion open at a time
const pdpAccordions = () => {
    const container = document.querySelector('.wt-product .wt-product__info')

    if (!container) return

    const triggers = container.querySelectorAll('.wt-collapse__trigger')

    if (!triggers.length) return

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            if (!trigger.classList.contains('wt-collapse__trigger--active')) {
                const id = trigger.getAttribute('aria-controls')

                const activeTriggers = container.querySelectorAll('.wt-collapse__trigger.wt-collapse__trigger--active')
                activeTriggers.forEach(activeTrigger => {
                    if (id !== activeTrigger.getAttribute('aria-controls')) {
                        activeTrigger.classList.remove('wt-collapse__trigger--active')
                        activeTrigger.setAttribute('aria-expanded', 'false')
                        activeTrigger.parentElement.setAttribute('data-open', 'false')
                    }
                })
            }
        })
    })
}
pdpAccordions()

// Custom Loyalty header trigger
const loyaltyCustomTrigger = () => {
    const trigger = document.querySelector('.js-custom-loyalty-button')

    if (!trigger) return

    trigger.addEventListener('click', () => {
        document.querySelector('#marsello-widget-root .cp-launcher-btn')?.click()
    })
}
// loyaltyCustomTrigger() commenting out as we're changing this button to go straight to NYRewards page

// Custom wishlist window trigger
const wishlistCustomTrigger = () => {
    const trigger = document.querySelector('.js-custom-wishlist-button')

    if (!trigger) return

    trigger.addEventListener('click', e => {
        e.preventDefault()
        document.querySelector('button.wishlist-fix.wishlist-page-widget')?.click()
    })
}
wishlistCustomTrigger()

// NYR static quick add buttons -> make buttons primary theme
const nyrStaticQuickAddButtons = () => {
    const buttons = document.querySelectorAll('.nyr-static-quick-add-container button[name="add"], .nyr-static-quick-add-container .custom-add-to-cart-button')

    buttons.forEach(button => {
        button.classList.add('hero__button--primary')
        button.classList.remove('hero__button--secondary')
    })
}
nyrStaticQuickAddButtons()

// Home page -> make videos within video sections clickable
const makeVideosClickable = () => {
    if (!document.body.classList.contains('template-index')) return

    const sections = document.querySelectorAll('section.wt-video__section')
    sections.forEach(section => {
        const video = section.querySelector('video')
        const button = section.querySelector('a.hero__button[href]')

        if (!video || !button) return

        video.addEventListener('click', () => {
            window.location.href = button.href
        })
    })
}
makeVideosClickable()

// Make images clickable within a section
const makeImagesClickable = () => {
    const sections = 'section.section-image-with-text'

    document.querySelectorAll(sections).forEach(section => {
        const button = section.querySelector('a')

        if (!button) return

        section.querySelectorAll('picture').forEach(picture => {
            picture.style.cursor = 'pointer'
            picture.addEventListener('click', () => {
                window.location.href = button.href
            })
        })
    })
}
makeImagesClickable()